import { LocalStorageService } from "utils/localStorage";

import type { CrremSettings } from "../model/types";

import { parseCrremSettings } from "./parseCrremApi";

type SettingsListener = (settings: CrremSettings) => void;

const cache = new Map<string, CrremSettings>();
const listeners = new Map<string, Set<SettingsListener>>();

const storageKey = (projectId: string) => `energyAnalysisSettings:${projectId}`;
const legacyStorageKey = (projectId: string) => `crremSettings:${projectId}`;

export const readEnergyAnalysisSettings = (projectId: string) => {
  const cached = cache.get(projectId);
  if (cached) return cached;
  const stored = LocalStorageService.getItem(storageKey(projectId));
  const loaded = parseCrremSettings(stored ?? LocalStorageService.getItem(legacyStorageKey(projectId)));
  cache.set(projectId, loaded);
  return loaded;
};

export const writeEnergyAnalysisSettings = (projectId: string, next: CrremSettings) => {
  const parsed = parseCrremSettings(next);
  cache.set(projectId, parsed);
  LocalStorageService.setItem(storageKey(projectId), parsed);
  listeners.get(projectId)?.forEach((listener) => listener(parsed));
  return parsed;
};

export const subscribeEnergyAnalysisSettings = (projectId: string, listener: SettingsListener) => {
  const group = listeners.get(projectId) ?? new Set<SettingsListener>();
  group.add(listener);
  listeners.set(projectId, group);
  return () => {
    group.delete(listener);
    if (group.size === 0) listeners.delete(projectId);
  };
};
